<template>
  <div class="sign-page">
    <div class="form-dic">
      <div class="font-s-32 center" style="margin-bottom: 32px">登 录</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="账号" prop="user_name">
          <el-input
            v-model="ruleForm.user_name"
            placeholder="请输入用户名"
            class="w240"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="请输入密码"
            class="w240"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="w240"
            v-loading="loading"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {
        user_name: "",
        password: "",
      },
      rules: {
        user_name: [
          { required: true, message: "用户名不能为空", trigger: "change" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/v1/pub/sign/sign", this.ruleForm)
            .then((response) => {
              this.loading = false;
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "登录成功",
                  type: "success",
                });

                localStorage.setItem("token", res.data.token);
                localStorage.setItem("uid", res.data.uid);
                localStorage.setItem("user_name", res.data.user_name);
                localStorage.setItem("real_name", res.data.real_name);
                localStorage.setItem("avatar", res.data.avatar);
                setTimeout(() => {
                  this.redirect("/");
                }, 1000);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.sign-page {
  text-align: center;
}
.sign-page .form-dic {
  border-radius: 5px;
  width: 488px;
  margin: 100px auto;
  text-align: left;
  box-shadow: 1px 1px 3px #dfdfdf;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/Index.vue